import { createSelector } from 'reselect';
import { playerModalSelector } from './simple-selector';

export const PlayerModalPredictedSelector = createSelector(
    playerModalSelector,
    (playerModal) => playerModal.predicted
);
